import UserAvatar from '../../ui-kit/components/atoms/UserAvatar'
import ActionButton from '../../ui-kit/components/atoms/buttons/ActionButton'
import {HORIZONTAL_DOTS_ICON} from '../../ui-kit/helpers/icons/horizontal-dots'
import IconText from '../../ui-kit/components/molecules/IconText'
import {FIX_ICON} from '../../ui-kit/helpers/icons/fix'
import FloatContainer from '../../ui-kit/components/wrappers/FloatContainer'
import DropdownItem from '../../ui-kit/components/atoms/items/DropdownItem'
import ReactionButton from '../atoms/buttons/ReactionButton'
import CommentButton from '../atoms/buttons/CommentButton'
import RespondForm from '../molecules/RespondForm'
import PublicationImages from '../molecules/PublicationImages'
import PublicationFiles from '../molecules/PublicationFiles'
import {useState} from 'react'
import {getFormattedDate, getFullDate} from '../../helpers/dayjs'
import {answerData} from '../../helpers/data/answer-data'
import uniqid from 'uniqid'
import CommentPublication from '../molecules/CommentPublication'
import ReactionCounter from '../molecules/ReactionCounter'

const Publication = ({data}) => {
  const [showComments, setShowComments] = useState(false)
  return (
    <article className={`publication n-container ${data?.is_fixed && 'is-fixed'}`}>
      <header className="header">
        <div className="user">
          <UserAvatar picture={data?.author.picture} className="big" />
          <div>
            <p className="name">{`${data?.author.firstname} ${data?.author.lastname}`}</p>
            <time className="time" title={getFullDate(data?.created_at)}>
              {getFormattedDate(data?.created_at)}
            </time>
          </div>
        </div>
        <div className="right">
          {data?.is_fixed && <IconText className="small" text="Fijada" icon={FIX_ICON} />}
          <div>
            <FloatContainer>
              <ActionButton onClick={() => {}} icon={HORIZONTAL_DOTS_ICON} />
              <div className="float-container right-side">
                <DropdownItem text="Fijar" />
                <DropdownItem text="Editar" />
                <DropdownItem text="Eliminar" />
              </div>
            </FloatContainer>
          </div>
        </div>
      </header>
      <div className="content">
        <p>{data?.comment}</p>
        {data?.attachments_url.length > 0 && data?.attachments_type === 'IMAGE' ? (
          <PublicationImages images={data?.attachments_url} />
        ) : (
          <PublicationFiles files={data?.attachments_url} />
        )}
      </div>
      <footer className="footer">
        <div className="buttons">
          <ReactionButton />
          <CommentButton
            onClick={() => setShowComments(!showComments)}
            text={
              data?.stats.answers > 0 ? `${data?.stats.answers} comentarios` : 'Comentar'
            }
          />
        </div>
        <ReactionCounter
          reactions={data?.last_reactions}
          counter={data?.stats.reactions}
        />
      </footer>
      {showComments && (
        <section className="comment-section">
          <RespondForm />
          {answerData?.data?.map(answer => (
            <CommentPublication publication={data} data={answer} key={uniqid()} />
          ))}
        </section>
      )}
    </article>
  )
}

export default Publication
